import { HttpClient } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import WKT from 'ol/format/WKT';
import { LineString, Point, Polygon } from 'ol/geom';

import { Draw } from 'ol/interaction';
import VectorLayer from 'ol/layer/Vector';

import VectorSource from 'ol/source/Vector';
import { Fill, Icon, Stroke, Style, Circle } from 'ol/style';
import { CaptureToolService } from '../../../services/Capture-Tool/capture-tool.service';
import { MapServiceService } from '../../../services/Map-service/map-service.service';
import { SideNavService } from '../../../services/sidenav/side-nav.service';


import { AddCaptureFeatureComponent } from './add-capture-feature/add-capture-feature.component';
import { wmsLayer } from '../../map/wms_layers';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-capture-tool',
  templateUrl: './capture-tool.component.html',
  styleUrls: ['./capture-tool.component.css']
})
export class CaptureToolComponent implements OnInit, OnDestroy {
  checked = false;
  disabled = false;
  html: any
  showPanel = false
  selectMenu = false
  clickedIndex: any
  clickIndex: any
  newFeature: any
  addFeature: any
  saveNewFeature = false
  wasteWaterName: any
  drawType: any
  icon: any
  captureDrawSource: any
  rmInteraction: any
  draw: any
  pointGeometry: any
  polygonGeometry: any
  sketch: any
  listener: any
  lineStringGeometry: any
  layerName: any
  selectLayer = false
  boundaries: any
  dropDownHeadings: any = []
  dropDown: any = []
  legend: any
  lastIndex: any = []
  lastDrop: any = []
  togglePanel: any = {};
  objectKeys = Object.keys;
  refineLayersData: any = {};
  geomType: any
  keys: any;
  typeGrometry: any
  logEvent: any
  eventName: any
  mapId: any;
  val: any
  ids: any
  capturelayersToolTip = '<span>Select layer to add features.</span>'
  myOptions2 = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class2',
  };
  constructor(
    public mapService: MapServiceService,
    private http: HttpClient,
    private sideNavService: SideNavService,
    public dialog: MatDialog,
    public captureService: CaptureToolService,
    public auth: AuthService,
  ) { }

  ngOnInit(): void {
    this.togglePanel[0] = true
    this.mapService.layerGeomType.subscribe((res: any) => {
      // console.log('res', res.types)
      this.mapService.captureLayersId = Object.keys(res.types)
      this.geomType = res.types
    })
    this.mapService.captureFeature.subscribe((res: any) => {
      this.val = res
    })
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
    this.html = this.mapService.accessMapApi.map_data.map_data.tool_desc['capture']
    this.boundaries = this.mapService.mapData.map_data.map_data.layers;

    // console.log(this.boundaries)
    this.saveNewFeature = false;
    this.captureDrawSource = new VectorSource();
    this.mapService.captureVectorLayer = new VectorLayer({
      source: this.captureDrawSource,
    })
    this.mapService.mapLayer.addLayer(this.mapService.captureVectorLayer);
    this.mapService.selectLayer = false

    for (let i = 0; i < this.boundaries.length; i++) {
      if (!this.dropDownHeadings.includes(this.boundaries[i].legend.heading)) {
        this.dropDownHeadings.push(this.boundaries[i].legend.heading)
      }
    }
    // console.log(this.dropDownHeadings);

    for (let i = 0; i < this.boundaries.length; i++) {

      // Heading is  present && classgroup is not present
      if (!this.boundaries[i].legend.class_group && this.boundaries[i].legend.heading in this.refineLayersData) {
        if (this.boundaries[i].capture == true) {
          this.refineLayersData[this.boundaries[i].legend.heading].layers.push(this.boundaries[i]);
        }

        // Heading is  not present && classgroup is not present
      } else if (!this.boundaries[i].legend.class_group && !(this.boundaries[i].legend.heading in this.refineLayersData)) {

        if (this.boundaries[i].capture == true) {
          this.refineLayersData[this.boundaries[i].legend.heading] = { layers: [] }
          this.refineLayersData[this.boundaries[i].legend.heading].layers.push(this.boundaries[i]);
        }

      }
      // Heading is  not present && classgroup is present

      else if (this.boundaries[i].legend.class_group && !(this.boundaries[i].legend.heading in this.refineLayersData)) {
        if (this.boundaries[i].capture == true) {
          // this.refineLayersData[this.boundaries[i].legend.heading][this.boundaries[i].legend.class_group] = []
          this.refineLayersData[this.boundaries[i].legend.heading][this.boundaries[i].legend.class_group] = []
        }

      }
      // Heading is  present && classgroup is not present
      else if (!(this.boundaries[i].legend.class_group in this.refineLayersData[this.boundaries[i].legend.heading]) && (this.boundaries[i].legend.heading in this.refineLayersData)) {
        if (this.boundaries[i].capture == true) {
          // this.refineLayersData[this.boundaries[i].legend.heading][this.boundaries[i].legend.class_group] = []
          this.refineLayersData[this.boundaries[i].legend.heading][this.boundaries[i].legend.class_group] = []
          this.refineLayersData[this.boundaries[i].legend.heading][this.boundaries[i].legend.class_group].push(this.boundaries[i])
        }

      }
      //heading is present and class group is present
      else if ((this.boundaries[i].legend.class_group in this.refineLayersData[this.boundaries[i].legend.heading]) && (this.boundaries[i].legend.heading in this.refineLayersData)) {
        if (this.boundaries[i].capture == true) {
          // this.refineLayersData[this.boundaries[i].legend.heading][this.boundaries[i].legend.class_group] = []
          this.refineLayersData[this.boundaries[i].legend.heading][this.boundaries[i].legend.class_group].push(this.boundaries[i])
        }

      }

    }

    // delete capture Feature
    this.mapService.deleteCaptureFeatureData.subscribe((res: any) => {
      this.deleteCapture(res);
    });
  }
  deleteCapture(res: any) {
    const backSource = this.mapService.result.getSource();
    const features = this.mapService.listResult.getFeatures();
    for (let i = 0; i < features.length; i++) {
      if (features[i].get('id') == res.id) {
        features[i].setStyle(new Style({}));
        features[i].set('visible', false);
        backSource.removeFeature(features[i]);
      }
    }
  }
  newFeacture(value: boolean) {
    this.addFeature = value
    this.mapService.setcapture(this.addFeature)
    if (this.layerName !== undefined) {
      this.getLayerData(this.mapService.captureLayerData, this.mapService.captureLayerIndex)
    }
  }
  toggleClass(i: any) {
    this.eventName = i
    this.activityLoging()
  }

  getLayerData(data: any, i: any) {
    this.mapService.captureVectorLayer && this.mapService.captureVectorLayer.getSource().clear()
    this.mapService.captureLayerData = data;
    this.mapService.captureLayerIndex = i;
    this.mapService.captureLayer = data
    for (const [key, value] of Object.entries(this.geomType)) {
      if (key == data.id) {
        // console.log(value)
        if (value === 'POINT') {
          this.typeGrometry = value
          this.drawType = 'Point'
        } else if (value === 'MULTIPOINT') {
          this.typeGrometry = value
          this.drawType = 'Point'
        }
        else if (value === 'MULTILINESTRING') {
          this.typeGrometry = value
          this.drawType = 'LineString'
        }
        else if (value === 'MULTIPOLYGON') {
          this.typeGrometry = value
          this.drawType = 'Polygon'
        } else if (value === 'POLYGON') {
          this.typeGrometry = value
          this.drawType = 'Polygon'
        } else if (value === 'LINESTRING') {
          this.typeGrometry = value
          this.drawType = 'LineString'
        }
      }
    }
    this.clickIndex = null;
    this.captureService.clickedIndex = i;
    this.mapService.selectLayer = true
    this.layerName = data.name
    if (this.val && this.layerName) {
      this.mapService.featureIcon = data.legend.icon
      this.sideNavService.rightMenuClicked({
        component: AddCaptureFeatureComponent,
        history: false,
        push: false
      });
      this.sideNavService.sideNavState('open');
      this.mapService.mapLayer.updateSize();
      this.captureService.drawFeature = this.draw
      this.mapService.mapLayer.removeInteraction(this.draw);
      this.mapService.getdrawEnable(true)
      this.addInteraction();

    } else {
      this.mapService.featureIcon = data.legend.icon
    }

    const elem = data.id
    this.laterVisibility(elem)
  }

  laterVisibility(elem: any): void {
    if(this.ids) {
      this.mapService.ChangeLayerClickToZoom = []
      this.mapService.bookMarkShowLayers = []
      const layer = this.boundaries.find((user: any) => user.id === this.ids);
      if(layer) {
        let li = null;
          const ld = layer
          switch (ld.map.format) {
            case 'WMS':
              li = wmsLayer(ld, this.mapService.baseLayerName, 0, this.auth.user ? this.auth.user.user.id : 0);
                break;
            case 'WIND':
              li = wmsLayer(ld, this.mapService.baseLayerName, 0, this.auth.user ? this.auth.user.user.id : 0);
                break;
            default:
              ''
          }
          li!.setProperties({ mapport: ld, heading: ld['heading'] });
          li!.setProperties({ title: ld.name });
          li!.setProperties({ isVisible: false });
          li!.setProperties({ isChecked: false });
          const temp = li!.getProperties();
          temp.mapport.map.visible = false;
          li!.setProperties({ mapport: temp.mapport });
          this.mapService.layersData.push(li);
          const headingTitle = ld.name;
          const checked = false
          const id= ld.id
              const data = {
                headingTitle,id, checked
              };
              this.mapService.ChangeLayerClickToZoom.push(data);
          this.mapService.bookMarkShowLayers.push('Boundaries')
          this.mapService.bookMarkShowLayers.push(ld.legend.heading);
          this.mapService.setChangeLayerClickToZoom(
            this.mapService.ChangeLayerClickToZoom
          );
          this.mapService.setLayerHeadingForbookMark(
            this.mapService.bookMarkShowLayers
          );
      }
      this.ids = null
    }
    const layer = this.boundaries.find((user: any) => user.id === elem);
    if(layer) {
      this.mapService.ChangeLayerClickToZoom = []
    this.mapService.bookMarkShowLayers = []
      let li = null;
        const ld = layer
        switch (ld.map.format) {
          case 'WMS':
            li = wmsLayer(ld, this.mapService.baseLayerName, 0, this.auth.user ? this.auth.user.user.id : 0);
              break;
          case 'WIND':
            li = wmsLayer(ld, this.mapService.baseLayerName, 0, this.auth.user ? this.auth.user.user.id : 0);
              break;
          default:
            ''
        }
        li!.setProperties({ mapport: ld, heading: ld['heading'] });
        li!.setProperties({ title: ld.name });
        li!.setProperties({ isVisible: true });
        li!.setProperties({ isChecked: true });
        const temp = li!.getProperties();
        temp.mapport.map.visible = true;
        li!.setProperties({ mapport: temp.mapport });
        this.mapService.layersData.push(li);
        const headingTitle = ld.name;
        const checked = true
        const id= ld.id
        const data = {
          headingTitle,id,checked
        };
        this.mapService.ChangeLayerClickToZoom.push(data);
        this.mapService.bookMarkShowLayers.push('Boundaries')
        this.mapService.bookMarkShowLayers.push(ld.legend.heading);
        this.mapService.setChangeLayerClickToZoom(
          this.mapService.ChangeLayerClickToZoom
        );
        this.mapService.setLayerHeadingForbookMark(
          this.mapService.bookMarkShowLayers
        );
        this.ids = elem
    }
  }

  addInteraction() {
    const layer = this.mapService.captureVectorLayer;
    this.draw = new Draw({
      source: layer.getSource(),
      type: this.drawType,
      style: new Style({
        image: new Circle({
          radius: 6,
          fill: new Fill({
            color: 'rgb(238, 153, 0 , 0.3)',
          }),
          stroke: new Stroke({
            color: 'rgb(238, 153, 0)',
            width: 2,
          }),
        }),
      }),
    });
    this.rmInteraction = this.draw;
    this.captureService.drawFeature = this.draw
    this.mapService.mapLayer.addInteraction(this.draw);
    this.draw.on('drawstart', (evt: any) => {
      this.sketch = evt.feature;
      const polystyle = new Style({
        fill: new Fill({
          color: 'rgb(238, 153, 0 , 0.3)',
        }),
        stroke: new Stroke({
          color: 'rgb(238, 153, 0)',
          width: 2,
        }),
      });
      this.sketch.setStyle(polystyle);
      const features = this.mapService.captureVectorLayer.getSource().getFeatures();
      features.forEach((feature: any) => {
        this.mapService.captureVectorLayer.getSource().removeFeature(feature);
      });
      this.listener = this.sketch.getGeometry().on('change', (evt: any) => {
        const geom = evt.target;
        if (geom instanceof LineString) {
          if (this.typeGrometry === 'MULTILINESTRING') {
            const wkt = new WKT();
            this.mapService.layerGeometry = wkt.writeGeometry(geom);
            this.mapService.layerGeometry = this.mapService.layerGeometry.replace("LINESTRING(", "MULTILINESTRING((").replace(")", "))");
            this.mapService.captureVectorLayer.changed()
          } else {
            const wkt = new WKT();
            this.mapService.layerGeometry = wkt.writeGeometry(geom);
            this.mapService.captureVectorLayer.changed()
          }

        } else if (geom instanceof Polygon) {
          if (this.typeGrometry === 'MULTIPOLYGON') {
            this.pointGeometry = '';
            this.polygonGeometry = '';
            const wkt = new WKT();
            this.mapService.layerGeometry = wkt.writeGeometry(geom);
            this.mapService.layerGeometry = this.mapService.layerGeometry.replace("POLYGON", "MULTIPOLYGON(").replace("))", ")))");
          } else {
            this.pointGeometry = '';
            this.polygonGeometry = '';
            const wkt = new WKT();
            this.mapService.layerGeometry = wkt.writeGeometry(geom);
          }

        }
      });
    })
    this.draw.on('drawend', (evt: any) => {
      const geom = evt.feature.getGeometry();
      if (geom instanceof Point) {
        const s = new Style({
          image: new Icon({
            crossOrigin: 'anonymous',
            src: '/assets/img/anotation-marker.png',
            imgSize: [40, 40],
            // scale: 0.5,
          }),
        });
        evt.feature.setStyle(s);
        if (this.typeGrometry === 'MULTIPOINT') {
          this.pointGeometry = '';
          this.polygonGeometry = '';
          this.pointGeometry = '';
          const wkt = new WKT();
          this.mapService.layerGeometry = wkt.writeGeometry(geom);
          this.mapService.layerGeometry = this.mapService.layerGeometry.replace("POINT", "MULTIPOINT");
          this.mapService.captureVectorLayer.changed()
        } else {
          this.pointGeometry = '';
          this.polygonGeometry = '';
          this.pointGeometry = '';
          const wkt = new WKT();
          this.mapService.layerGeometry = wkt.writeGeometry(geom);
          this.mapService.captureVectorLayer.changed()
        }
      }
      this.captureService.drawFeature = this.draw
      this.mapService.mapLayer.removeInteraction(this.draw);
      this.mapService.captureVectorLayer && this.mapService.captureVectorLayer.getSource().clear()
    });
  }


  activityLoging() {
    this.logEvent = 'click'
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapService.ipAddress = res.ip;
        const body = {
          map_id: this.mapId,
          event: this.logEvent,
          page: this.mapService.pageUrl,
          basemap: this.sideNavService.currentLoadedMap,
          event_name: this.eventName,
          ip: this.mapService.ipAddress,
          time: this.mapService.getTimeOnPage().toString(),
          point: '',
          wkt: '',

        }
        this.mapService.activityLogs(body).subscribe(() => {
          // console.log(res)
        }, (error: any) => {
          if (error.status == 403) {
            location.reload();
          }
        })
      })
  }

  closeLeft() {

    this.mapService.closePanel = true
    this.mapService.setClosePanel(true);
  }

  ngOnDestroy(): void {
    this.mapService.mapLayer.removeInteraction(this.draw);
    this.sideNavService.closeRightSideNav();
    if (this.mapService.result) {
      this.mapService
        .result.getSource().clear();
    }
    const source = this.mapService.captureVectorLayer.getSource();
    const features = source.getFeatures();
    features.forEach((feature: any) => {
      source.removeFeature(feature);
    });
    this.captureService.clickedIndex = null
    this.mapService.captureLayerData = null
  }
}
